export const demo_zh = {
  session: '会话',
  addressText: '通讯录',
  sdkVersionSelectionText: 'sdk版本选择',
  p2pMsgVisibleModeText: '是否显示p2p消息已读未读',
  teamMsgVisibleModeText: '是否显示群消息已读未读',
  addFriendMode: '添加好友模式',
  logoutText: '退出登录',
  yesText: '是',
  noText: '否',
  needVerifyText: '需要验证',
  notNeedVerifyText: '不需要验证',
  oppositeSide: '对方',
  settingText: '设置',
  logoutConfirmText: '确定退出登录吗?',
  voiceCallText: '语音通话',
  vedioCallText: '视频通话',
  callDurationText: '通话时长',
  callCancelText: '已取消',
  callRejectedText: '已拒绝',
  callTimeoutText: '超时未接听',
  callBusyText: '忙碌未接听',
  networkDisconnectText: '网络连接已断开，请检查您的网络设置并尝试重新连接',
  callFailed: '呼叫失败',
  inCallText: '已在通话中，请结束通话后再呼叫',
  passFriendAskText: '我已经同意了你的申请，现在开始聊天吧~',
  needMentionText: '是否需要@消息',
  teamManagerEnableText: '是否开启群管理员功能',
  deleteText: '删除',
  collectionText: '收藏',
  languageText: '语言',
  zhText: '中文',
  enText: 'English',
  securityTipText:
    '仅用于体验云信IM 产品功能，请勿轻信汇款、中奖等涉及钱款的信息，勿轻易拨打陌生电话，谨防上当受骗。',
  enableV2CloudConversationText: '是否开启云端会话',
  aiStreamText: '数字人流式输出',
  teamJoinModeText: '(用户)申请入群的模式',
  teamJoinModeFreeText: '自由加入，无须验证',
  teamJoinModeNeedVerifyText: '需申请，群主或管理同意后加入',
  teamAgreeModeText: '邀请入群时是否需要被邀请人的同意模式',
  needBeInvitedText: '需要被邀请人同意',
  notNeedBeInvitedText: '不需要被邀请人同意',
}

export const demo_en = {
  session: 'session',
  addressText: 'contacts',
  sdkVersionSelectionText: 'SDK version',
  p2pMsgVisibleModeText: 'Read receipts for private messages',
  teamMsgVisibleModeText: 'Read receipts for group messages',
  addFriendMode: 'Verification for friend requests',
  logoutText: 'Sign out',
  yesText: 'Enable',
  noText: 'Disable',
  needVerifyText: 'Required',
  notNeedVerifyText: 'Not required',
  settingText: 'setting',
  logoutConfirmText: 'Are you sure you log out?',
  voiceCallText: 'Voice Call',
  vedioCallText: 'Vedio Call',
  callDurationText: 'call duration',
  callCancelText: 'canceled',
  callRejectedText: 'rejected',
  callTimeoutText: 'Missed call',
  callBusyText: 'busy line',
  oppositeSide: 'The opposite side',
  networkDisconnectText:
    'The network connection has been disconnected. Please check your network settings and try to reconnect.',
  callFailed: 'call failed',
  inCallText: 'Already in a call, please try again after ending the call',
  passFriendAskText: "I have approved your request, let's start chatting now~",
  needMentionText: 'Whether or not an @ message is needed',
  teamManagerEnableText: 'Whether or not team manager is needed',
  deleteText: 'delete',
  collectionText: 'collection',
  zhText: '中文',
  enText: 'English',
  securityTipText:
    'Only for testing the Netease IM , please do not believe in money transfer, lottery winning and so on. Do not easily call strangers.',
  enableV2CloudConversationText: 'Whether or not to enable cloud conversation',
  aiStreamText: 'AI Stream',
  teamJoinModeText: 'Team join mode',
  teamJoinModeFreeText: 'Free join, no verification required',
  teamJoinModeNeedVerifyText:
    'Need to apply, join after the group owner or manager approves',
  teamAgreeModeText: 'Team agree mode',
  needBeInvitedText: 'Need to be invited by the invitee',
  notNeedBeInvitedText: 'No need to be invited by the invitee',
}
export const demo_cht = {
  session: '會話',
  addressText: '通訊錄',
  sdkVersionSelectionText: 'SDK 版本選擇',
  p2pMsgVisibleModeText: '是否顯示 P2P 訊息已讀未讀',
  teamMsgVisibleModeText: '是否顯示群組訊息已讀未讀',
  addFriendMode: '加好友模式',
  logoutText: '登出',
  yesText: '是',
  noText: '否',
  needVerifyText: '需要驗證',
  notNeedVerifyText: '不需要驗證',
  oppositeSide: '對方',
  settingText: '設定',
  logoutConfirmText: '確定要登出嗎？',
  voiceCallText: '語音通話',
  vedioCallText: '視訊通話',
  callDurationText: '通話時長',
  callCancelText: '已取消',
  callRejectedText: '已拒絕',
  callTimeoutText: '通話逾時',
  callBusyText: '對方忙碌中',
  networkDisconnectText: '網路連線已中斷，請檢查設定後重試',
  callFailed: '呼叫失敗',
  inCallText: '已在通話中，請先結束通話',
  passFriendAskText: '我已同意您的申請，現在可以開始聊天囉~',
  needMentionText: '是否需要 @ 提醒',
  teamManagerEnableText: '是否開啟群組管理員功能',
  deleteText: '刪除',
  collectionText: '收藏',
  languageText: '語言',
  zhText: '中文',
  enText: 'English',
  securityTipText:
    '僅用於體驗雲信IM 產品功能，請勿輕信匯款、中獎等涉及錢款的信息，勿輕易撥打陌生電話，謹防上當受騙。',
  enableV2CloudConversationText: '是否開啟雲端會話',
  aiStreamText: '數字人流式輸出',
  teamJoinModeText: '(用戶)申請入群的模式',
  teamJoinModeFreeText: '自由加入，無須驗證',
  teamJoinModeNeedVerifyText: '需申請，群主或管理同意後加入',
  teamAgreeModeText: '邀請入群時是否需要被邀請人的同意模式',
  needBeInvitedText: '需要被邀請人同意',
  notNeedBeInvitedText: '不需要被邀請人同意',
}

export const demo_tr = {
  session: 'session',
  addressText: 'contacts',
  sdkVersionSelectionText: 'SDK version',
  p2pMsgVisibleModeText: 'Read receipts for private messages',
  teamMsgVisibleModeText: 'Read receipts for group messages',
  addFriendMode: 'Verification for friend requests',
  logoutText: 'Sign out',
  yesText: 'Enable',
  noText: 'Disable',
  needVerifyText: 'Required',
  notNeedVerifyText: 'Not required',
  settingText: 'setting',
  logoutConfirmText: 'Are you sure you log out?',
  voiceCallText: 'Voice Call',
  vedioCallText: 'Vedio Call',
  callDurationText: 'call duration',
  callCancelText: 'canceled',
  callRejectedText: 'rejected',
  callTimeoutText: 'Missed call',
  callBusyText: 'busy line',
  oppositeSide: 'The opposite side',
  networkDisconnectText:
    'The network connection has been disconnected. Please check your network settings and try to reconnect.',
  callFailed: 'call failed',
  inCallText: 'Already in a call, please try again after ending the call',
  passFriendAskText: "I have approved your request, let's start chatting now~",
  needMentionText: 'Whether or not an @ message is needed',
  teamManagerEnableText: 'Whether or not team manager is needed',
  deleteText: 'delete',
}
export const demo_th = {
  session: "การประชุม",
  addressText: "ติดต่อเรา",
  sdkVersionSelectionText: "การเลือกเวอร์ชัน SDK",
  p2pMsgVisibleModeText: "ว่าจะแสดงข้อความ p2p ว่าอ่านแล้วหรือยังไม่ได้อ่าน",
  teamMsgVisibleModeText: "ว่าจะแสดงข้อความกลุ่มว่าอ่านแล้วหรือยังไม่ได้อ่าน",
  addFriendMode: "โหมดเพิ่มเพื่อน",
  logoutText: "ออกจากระบบ",
  yesText: "ใช่",
  noText: "เลขที่",
  needVerifyText: "ต้องมีการตรวจสอบ",
  notNeedVerifyText: "ไม่ต้องมีการตรวจยืนยัน",
  oppositeSide: "อีกด้านหนึ่ง",
  settingText: "ตั้งค่า",
  logoutConfirmText: "คุณแน่ใจว่าต้องการออกจากระบบหรือไม่?",
  voiceCallText: "การโทรด้วยเสียง",
  vedioCallText: "วิดีโอคอล",
  callTimeoutText2: "หมดเวลาและไม่มีคำตอบ",
  callBusyText2: "ยุ่งพลาด",
  networkDisconnectText: "การเชื่อมต่อเครือข่ายขาดหาย โปรดตรวจสอบการตั้งค่าเครือข่ายของคุณและลองเชื่อมต่อใหม่อีกครั้ง",
  callFailed: "การโทรล้มเหลว",
  inCallText: "กำลังคุยโทรศัพท์อยู่ กรุณาวางสายก่อนโทรอีกครั้ง",
  passFriendAskText: "ฉันอนุมัติใบสมัครของคุณแล้ว มาเริ่มแชทกันเลย~",
  needMentionText: "คุณต้องการ @ข้อความหรือไม่?",
  teamManagerEnableText: "ว่าจะเปิดใช้งานฟังก์ชั่นผู้ดูแลกลุ่มหรือไม่",
  callDurationText: "เวลาพูดคุย",
  callCancelText: "ยกเลิก",
  callRejectedText: "ถูกปฏิเสธ",
  callTimeoutText: "หมดเวลาแล้ว",
  callBusyText: "อีกฝ่ายก็ยุ่งอยู่",
  deleteText: "ลบ",
}
export const demo_ru = {
  session: "Сессия",
  addressText: "Контакты",
  sdkVersionSelectionText: "Выбор версии SDK",
  p2pMsgVisibleModeText: "Отображать ли прочитанные и непрочитанные сообщения p2p",
  teamMsgVisibleModeText: "Отображать ли групповые сообщения как прочитанные или непрочитанные",
  addFriendMode: "Режим «Добавить друга»",
  logoutText: "Выйти",
  yesText: "да",
  noText: "нет",
  needVerifyText: "Требуется проверка",
  notNeedVerifyText: "Проверка не требуется",
  oppositeSide: "Другая сторона",
  settingText: "настраивать",
  logoutConfirmText: "Вы уверены, что хотите выйти?",
  voiceCallText: "Голосовой вызов",
  vedioCallText: "Видеозвонки",
  callTimeoutText2: "Тайм-аут и нет ответа",
  callBusyText2: "Занят Пропущено",
  networkDisconnectText: "Сетевое соединение потеряно, проверьте настройки сети и попробуйте подключиться заново.",
  callFailed: "Вызов не удался",
  inCallText: "Вы уже разговариваете по телефону. Пожалуйста, завершите разговор, прежде чем звонить снова.",
  passFriendAskText: "Я одобрил вашу заявку, давайте начнем общение прямо сейчас~",
  needMentionText: "Вам нужно @сообщение?",
  teamManagerEnableText: "Включать ли функцию администратора группы",
  callDurationText: "Время разговора",
  callCancelText: "Отменено",
  callRejectedText: "Отклоненный",
  callTimeoutText: "Истек срок ожидания",
  callBusyText: "Другая сторона занята",
  deleteText: "удалить"
}
export const demo_ar = {
  session: "المحادثة",
  addressText: "جهات الاتصال",
  sdkVersionSelectionText: "تحديد إصدار SDK",
  p2pMsgVisibleModeText: "هل تظهر حالة الرسائل p2p (قرأ / لم يقرأ)؟",
  teamMsgVisibleModeText: "هل تظهر رسائل المجموعة كـ unread أو read",
  addFriendMode: "وضع إضافة الصديق",
  logoutText: "تسجيل خروج",
  yesText: "نعم",
  noText: "لا",
  needVerifyText: "يحتاج إلى التأكد والتحقق",
  notNeedVerifyText: "غير مطلوب التحقق",
  oppositeSide: "الطرف الآخر",
  settingText: "الإعدادات",
  logoutConfirmText: "هل تأكد من تسجيل الخروج؟",
  voiceCallText: "الدردشة الصوتيyah",
  vedioCallText: "الاتصال المرئي",
  callTimeoutText2: "متأخر للرد",
  callBusyText2: "مشغول فاتني",
  networkDisconnectText: "تم فقد اتصال الشبكة، يرجى التحقق من إعدادات الشبكة ومحاولة إعادة الاتصال",
  callFailed: "فشل الاتصال",
  inCallText: "أنت الآن في مكالمة، يرجى إنهاء المكالمة قبل الاتصال مرة أخرى",
  passFriendAskText: "لقد وافقت على طلبك، فلنبدأ الدردشة الآن~",
  needMentionText: "هل تحتاج إلى @message؟",
  teamManagerEnableText: "ما إذا كان سيتم تمكين وظيفة مسؤول المجموعة",
  callDurationText: "مدة المكالمة",
  callCancelText: "تم إلغاؤه",
  callRejectedText: "مقبول",
  callTimeoutText: "منتهي المهلة",
  callBusyText: "الطرف الآخر مشغول",
  deleteText: "حذف",
}
export const demo_pt = {
  session: "Sessão",
  addressText: "Contatos",
  sdkVersionSelectionText: "SDK - Seleção de Versão",
  p2pMsgVisibleModeText: "Mostrar se as mensagens P2P estão lidas ou não lidas",
  teamMsgVisibleModeText: "Mostrar se as mensagens de grupo estão lidas ou não lidas",
  addFriendMode: "Modo de adicionar amigos",
  logoutText: "Sair da conta",
  yesText: "sim",
  noText: "Não",
  needVerifyText: "Requer verificação",
  notNeedVerifyText: "Não é necessário validar",
  oppositeSide: "o outro",
  settingText: "Configurações",
  logoutConfirmText: "Você realmente quer sair?",
  voiceCallText: "Conversa telefônica",
  vedioCallText: "Vídeo Chamada",
  callTimeoutText2: "Fora de hora",
  callBusyText2: "Ocupado",
  networkDisconnectText: "Sua conexão de rede foi desconectada. Por favor, verifique suas configurações de rede e tente reconnectar.",
  callFailed: "Falha na chamada",
  inCallText: "Em chamada, por favor, encerre a chamada e depois ligue novamente.",
  passFriendAskText: "Já concordei com o seu pedido, vamos começar a conversar~",
  needMentionText: "Precisa @mensagem",
  teamManagerEnableText: "Habilitar a função de administrador de grupo",
  callDurationText: "Duração da ligação",
  callCancelText: "Cancelado",
  callRejectedText: "Rejeitado",
  callTimeoutText: "Excedido o tempo",
  callBusyText: "O outro está ocupado",
  deleteText: "excluir",
}
export const demo_vie = {
  session: "Phiên họp",
  addressText: "Liên hệ",
  sdkVersionSelectionText: "Lựa chọn phiên bản SDK",
  p2pMsgVisibleModeText: "Hiển thị tin nhắn p2p đã đọc và chưa đọc",
  teamMsgVisibleModeText: "Hiển thị tin nhắn nhóm là đã đọc hay chưa đọc",
  addFriendMode: "Thêm chế độ bạn bè",
  logoutText: "Đăng xuất",
  yesText: "Đúng",
  noText: "KHÔNG",
  needVerifyText: "Yêu cầu xác minh",
  notNeedVerifyText: "Không cần xác minh",
  oppositeSide: "phía bên kia",
  settingText: "cài đặt",
  logoutConfirmText: "Bạn có chắc chắn muốn đăng xuất không?",
  voiceCallText: "Cuộc gọi thoại",
  vedioCallText: "Gọi video",
  callTimeoutText2: "Hết thời gian và không trả lời",
  callBusyText2: "Bận rộn bỏ lỡ",
  networkDisconnectText: "Kết nối mạng bị mất, vui lòng kiểm tra cài đặt mạng của bạn và thử kết nối lại",
  callFailed: "Cuộc gọi không thành công",
  inCallText: "Đang gọi điện, vui lòng kết thúc cuộc gọi trước khi gọi lại",
  passFriendAskText: "Tôi đã chấp thuận đơn đăng ký của bạn, chúng ta hãy bắt đầu trò chuyện ngay bây giờ nhé~",
  needMentionText: "Bạn có cần @message không?",
  teamManagerEnableText: "Có nên bật chức năng quản trị viên nhóm không",
  callDurationText: "Thời gian nói chuyện",
  callCancelText: "Đã hủy",
  callRejectedText: "Vật bị loại bỏ",
  callTimeoutText: "Đã hết thời gian",
  callBusyText: "Bên kia đang bận",
  deleteText: "xóa bỏ",
}
export const demo_kor = {
  session: "세션",
  addressText: "주소록",
  sdkVersionSelectionText: "sdk 버전 선택",
  p2pMsgVisibleModeText: "p2p 메시지 읽기 / 읽기 없음 표시 여부",
  teamMsgVisibleModeText: "그룹 메시지 읽기 / 읽기 없음 표시 여부",
  addFriendMode: "친구 추가 모드",
  logoutText: "로그인 종료",
  yesText: "예",
  noText: "아니오",
  needVerifyText: "검검증 필요",
  notNeedVerifyText: "검증 불필요",
  oppositeSide: "상대방",
  settingText: "설치",
  logoutConfirmText: "로그인을 종료하시겠습니까?",
  voiceCallText: "음성 통화",
  vedioCallText: "영상 통화",
  callTimeoutText2: "Hết thời gian và không trả lời",
  callBusyText2: "Bận rộn bỏ lỡ",
  networkDisconnectText: "네트워크 연결이 끊어졌습니다. 네트워크 설정을 확인하고 다시 연결하십시오.",
  callFailed: "호출 실패",
  inCallText: "이미 통화 중입니다. 통화를 마친 후에 다시 호출하십시오.",
  passFriendAskText: "나는 이미 너의 신청에 동의했으니 지금부터 이야기를 나누자 ~",
  needMentionText: "@ 메시지 필요 여부",
  teamManagerEnableText: "그룹 관리자 기능 설정 여부",
  callDurationText: "통화 시간",
  callCancelText: "취소됨",
  callRejectedText: "거부됨",
  callTimeoutText: "시간 초과됨",
  callBusyText: "상대방이 바쁘다",
  deleteText: "삭제",
}
export const demo_fra = {
  session: "Session",
  addressText: "Contacts",
  sdkVersionSelectionText: "Sélection de la version SDK",
  p2pMsgVisibleModeText: "Afficher le message P2P Lu non lu",
  teamMsgVisibleModeText: "Afficher le message de groupe Lu non lu",
  addFriendMode: "Ajouter un mode ami",
  logoutText: "Se déconnecter du login",
  yesText: "Oui",
  noText: "Non",
  needVerifyText: "Vérification requise",
  notNeedVerifyText: "Aucune vérification requise",
  oppositeSide: "L'autre partie",
  settingText: "Paramétrage",
  logoutConfirmText: "Êtes - vous sûr de vous déconnecter?",
  voiceCallText: "Appels vocaux",
  vedioCallText: "Appel vidéo",
  callTimeoutText2: "Hết thời gian và không trả lời",
  callBusyText2: "Bận rộn bỏ lỡ",
  networkDisconnectText: "La connexion réseau est déconnectée, vérifiez vos paramètres réseau et essayez de vous reconnecter",
  callFailed: "L'appel a échoué",
  inCallText: "Déjà en cours d'appel, terminez l'appel et appelez à nouveau",
  passFriendAskText: "J'ai accepté votre demande, commencez à discuter maintenant ~",
  needMentionText: "Le @ message est - il nécessaire",
  teamManagerEnableText: "Activer la fonction administrateur de groupe",
  callDurationText: "Durée de l'appel",
  callCancelText: "Annulé",
  callRejectedText: "Refusé",
  callTimeoutText: "A dépassé le temps",
  callBusyText: "L'autre est occupé",
  deleteText: "supprimer",
}
